import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dcc15ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__tabbed-content" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content" }

import { Component, computed, defineComponent, h, ref, useSlots } from 'vue'
  import {themingCssClass} from "vue/applications/frontend/mixins/theming-mixin"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'tabbed-content',
  props: {
    tabHeaders: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(__props) {

  const Vnodes = (props: any, context: any) =>{
    return h(props.vnodes, context.attrs, context.slots);
  }
  Vnodes.props = ['vnodes']

  const slots = useSlots();

  const props = __props;

  const currentSelection = ref<any>(null);

  const selectedSlot = computed(() => {
    if (currentSelection.value) {
      return slots[currentSelection.value];
    } else {
      return slots[Object.keys(slots)[0]];
    }
  });

  const slotHeader = (slotName: any, tabNames: any) => {
    if (Object.keys(tabNames).indexOf(slotName) >= 0) {
      return tabNames[slotName];
    } else {
      return slotName;
    }
  };

  const select = (tabName: any) => {
    currentSelection.value = tabName;
  };
  const slotCssClasses = (slot: any, name: any, index: number) => {
    const result = [];

    if (
      currentSelection.value === name ||
      (!currentSelection.value && index === 0)
    ) {
      result.push(themingCssClass("inverted"));
    } else {
      result.push(themingCssClass("normal"));
      result.push(themingCssClass("light_background"));
    }

    return result;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slots), (slot, name, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: name,
          class: _normalizeClass(["tab", slotCssClasses(slot, name, index)]),
          onClick: ($event: any) => (select(name))
        }, _toDisplayString(slotHeader(name, __props.tabHeaders)), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Vnodes, { vnodes: selectedSlot.value }, null, 8, ["vnodes"])
    ])
  ]))
}
}

})